<template>
  <div>
    <div class="headlines-container" :class="{badEquipment}">
      <div class="headlines-container__text" id="subheadline">{{ $t('cards.l1') }}<br class="br-mobile">{{ $t('cards.l2') }}</div>
    </div>

    <div class="player-block">
      <div class="player-box horizontal">
        <div id="player"></div>
        <div v-if="!badEquipment && time" class="transcript">
          <div>Spanish close captions are available in the CC drop down menu</div>
          <div>Transcript: <a :href="transcriptUrl + '_en.html'" target="_blank">English</a> |  <a :href="transcriptUrl + '_es.html'" target="_blank">Español</a></div>
        </div>
      </div>
      <div class="chapters" v-show="showChapters && !badEquipment">
        <div class="active">{{ $t('player.nowPlaying') }}: {{ activeChapter?.title }}</div>
        <div class="list" ref="chapters">
          <div tabindex=0 
            class="li"
            :class="{viewed:c.viewed}"
            v-for="(c,i) in chapters"
            :key="i"
            @click="setChapter(i)"
        v-on:keyup.enter="setChapter(i)"
            >
            {{ c.title }}
          </div>
        </div>        
      </div>
    </div>

    <div class="survey">
      <form class="survey-body" method="post" v-if="showForm && !sendedForm && !badEquipment">

        <div class="survey-question">
          <fieldset>
            <legend class="survey-question-question"><label for="q1">{{ $t('survey.q1.q') }}</label></legend>
            <span class="survey-radio-list">
              <span class="survey-radio"><input v-model="survey.q1" type="radio" name="q1" id="q1-1" :value="$t('survey.q1.a1')" /><label for="q1-1">{{ $t('survey.q1.a1') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q1" type="radio" name="q1" id="q1-2" :value="$t('survey.q1.a2')" /><label for="q1-2">{{ $t('survey.q1.a2') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q1" type="radio" name="q1" id="q1-3" :value="$t('survey.q1.a3')" /><label for="q1-3">{{ $t('survey.q1.a3') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q1" type="radio" name="q1" id="q1-4" :value="$t('survey.q1.a4')" /><label for="q1-4">{{ $t('survey.q1.a4') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q1" type="radio" name="q1" id="q1-5" :value="$t('survey.q1.a5')" /><label for="q1-5">{{ $t('survey.q1.a5') }}</label><br /></span>
            </span>
          </fieldset>
        </div>

        <div class="survey-question">
          <fieldset>
            <legend class="survey-question-question"><label for="q2">{{ $t('survey.q2.q') }}</label></legend>
            <span class="survey-radio-list">
              <span class="survey-radio"><input v-model="survey.q2" type="radio" name="q2" id="q2-1" :value="$t('survey.q2.a1')" /><label for="q2-1">{{ $t('survey.q2.a1') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q2" type="radio" name="q2" id="q2-2" :value="$t('survey.q2.a2')" /><label for="q2-2">{{ $t('survey.q2.a2') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q2" type="radio" name="q2" id="q2-3" :value="$t('survey.q2.a3')" /><label for="q2-3">{{ $t('survey.q2.a3') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q2" type="radio" name="q2" id="q2-4" :value="$t('survey.q2.a4')" /><label for="q2-4">{{ $t('survey.q2.a4') }}</label><br /></span>
            </span>
          </fieldset>
        </div>

        <div class="survey-question">
          <fieldset>
            <legend class="survey-question-question"><label for="q3">{{ $t('survey.q3.q') }}</label></legend>
            <span class="survey-radio-list">
              <span class="survey-radio"><input v-model="survey.q3" type="radio" name="q3" id="q3-1" @click="$q3_2 = false" :value="$t('survey.q3.a1')" /><label for="q3-1">{{ $t('survey.q3.a1') }}</label><br /></span>
              <span class="survey-radio">
                <input v-model="survey.q3" type="radio" aria-labelledby="label-q3-2-1 abel-q3-2-2" name="q3" id="q3-2" ref="q3_2" @click="$q3_2 = true" :value="$t('survey.q3.a2')" />
               <label for="q3-2" id="label-q3-2-1">{{ $t('survey.q3.a2') }}</label>
               <label for="q3-2" class="hidden" id="label-q3-2-2">{{ $t('survey.q3.a2') }}</label>
                <input
                  v-model="survey.q3_text"
                  v-if="$q3_2"
                  type="text"
                  aria-labelledby="label-q3-2-1 abel-q3-2-2"
                  name="q3"
                  id="q3-text"
                  placeholder="Please provide the reason"
                  @click="$refs.q3_2.checked = true; survey.q3 = $t('survey.q3.a2')"
                  @input="$refs.q3_2.checked = true; survey.q3 = $t('survey.q3.a2')"
                  class="input-radio"
                ><br />
              </span>
              <span class="survey-radio"><input v-model="survey.q3" type="radio" name="q3" id="q3-3" @click="$q3_2 = false" :value="$t('survey.q3.a3')" /><label for="q3-3">{{ $t('survey.q3.a3') }}</label><br /></span>
            </span>
          </fieldset>
        </div>

        <div class="survey-question">
          <fieldset>
            <legend class="survey-question-question"><label for="q4">{{ $t('survey.q4.q') }}</label></legend>
            <span class="survey-radio-list">

              <span class="survey-radio">
                <input v-model="survey.q4[0]" type="checkbox" name="q4" id="q4-1" :value="$t('survey.q4.a1')" />
                <label for="q4-1">{{ $t('survey.q4.a1') }}</label><br />
              </span>

              <span class="survey-radio">
                <input v-model="survey.q4[1]" type="checkbox" name="q4" id="q4-2" :value="$t('survey.q4.a2')" />
                <label for="q4-2">{{ $t('survey.q4.a2') }}</label><br />
              </span>

              <span class="survey-radio">
                <input v-model="survey.q4[2]" type="checkbox" name="q4" id="q4-3" :value="$t('survey.q4.a3')" />
                <label for="q4-3">{{ $t('survey.q4.a3') }}</label><br />
              </span>

              <span class="survey-radio">

                <input
                  v-model="survey.q4[3]"
                  type="checkbox"
                  aria-labelledby="label-q4-4-1 label-q4-4-2"
                  name="q4"
                  id="q4-4"
                  ref="q4_4"
                  @click="$q4_4 = $event.target.checked"
                  :value="$t('survey.q4.a4')" />

                <label for="q4-4" id="label-q4-4-1">{{ $t('survey.q4.a4') }}</label>
                <label for="q4-4" class="hidden" id="label-q4-4-2">{{ $t('survey.q4.a4') }}</label>

                <input
                  v-model="survey.q4_text"
                  v-if="$q4_4"
                  type="text"
                  name="q4"
                  aria-labelledby="label-q4-4-1 label-q4-4-2"
                  id="q4_text"
                  placeholder="Please provide the additional information"
                  @click="$refs.q4_4.checked = true; survey.q4[3] = true"
                  @input="$refs.q4_4.checked = true; survey.q4[3] = true"
                  class="input-radio"
                ><br />
              </span>

              <span class="survey-radio">
                <input v-model="survey.q4[4]" type="checkbox" name="q4" id="q4-5" :value="$t('survey.q4.a5')" />
                <label for="q4-5">{{ $t('survey.q4.a5') }}</label><br />
              </span>
            </span>
          </fieldset>
        </div>

        <div class="survey-question">
          <fieldset>
            <legend class="survey-question-question"><label for="q5">{{ $t('survey.q5.q') }}</label></legend>
            <span class="survey-radio-list">
              <span class="survey-radio"><input v-model="survey.q5" type="radio" name="q5" id="q5-1" :value="$t('survey.q5.a1')" /><label for="q5-1">{{ $t('survey.q5.a1') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q5" type="radio" name="q5" id="q5-2" :value="$t('survey.q5.a2')" /><label for="q5-2">{{ $t('survey.q5.a2') }}</label><br /></span>
              <span class="survey-radio"><input v-model="survey.q5" type="radio" name="q5" id="q5-3" :value="$t('survey.q5.a3')" /><label for="q5-3">{{ $t('survey.q5.a3') }}</label><br /></span>
            </span>
          </fieldset>
        </div>

        <div class="survey-question">
          <fieldset>
            <legend class="survey-question-question"><label for="q6">{{ $t('survey.q6.q') }}</label></legend>
            <textarea maxlength="254" name="q6" id="q6" multiline="true" row="5" cols="35" style="resize: none;" v-model="survey.q6"></textarea>
          </fieldset>
        </div>

        <input
          type="button"
          :title="$t('survey.submit')"
          :value="$t('survey.submit')"
          class="SurveySubmitButton"
          @click="postSurvey"
          :disabled="disabled"
        />

      </form>

      <div class="sendedForm" v-if="sendedForm">{{ $t('survey.thankYou') }}</div>

    </div>


  </div>
</template>

<script>
export default {
  name: 'PlayerComponent',
  data() {
    return {
      player_options: {
        build_url: 'https://liv.idomoo.com/',
        extension: 'hls',
        interactive: true,
        autoplay: false,
        idm_logo: false,
        toolbar_position: "low",
        share_button: false,
        mute: false,
        close_captions: [{
          srclang: "en",
          label: "English",
          default: false
        },{
          srclang: "es",
          label: "Español",
          default: false
        }],
        transcript: [{
          srclang: "en"
        },],
        opening_image: {
          image_url: null
        },
      },
      showChapters:false,
      showForm:false,
      sendedForm:false,
      chaptersData:[],
      chaptersViewed:{},
      time:0,
      survey:{
        q1: null,
        q2: null,
        q3: null,
        q3_text: "",
        q4: [null,null,null,null,null],
        q4_text: "",
        q5: null,
        q6: "",
      },
      surveyShowTime:null,
      disableAutoScroll:false,
      $q3_2:false,
      $q4_4:false,
      transcriptUrl:null,
    }
  },
  props:{
    badEquipment:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    chapters(){
      return this.chaptersData.map((c,i)=>{
        const active = this.time >= c.time && (!this.chaptersData[i+1] || this.time < this.chaptersData[i+1].time)
        if(active && !this.chaptersViewed[i]){
          this.chaptersViewed[i] = true
        }
        return {
          id:i,
          ...c,
          active,
          viewed: this.chaptersViewed[i] || false
        }
      })
    },
    activeChapter(){
      return this.chapters.find(c=>c.active)
    },
    disabled(){
      return !(this.survey.q1 || this.survey.q2 || this.survey.q3 || this.survey.q4 || this.survey.q5 || this.survey.q6)
    },
    answers(){
      let a4 = []
      if(this.survey.q4[0]){
        a4.push( this.$t('survey.q4.a1') )
      }
      if(this.survey.q4[1]){
        a4.push( this.$t('survey.q4.a2') )
      }
      if(this.survey.q4[2]){
        a4.push( this.$t('survey.q4.a3') )
      }
      if(this.survey.q4[3] && this.survey.q4_text.length){
        a4.push( this.$t('survey.q4.a4') + this.survey.q4_text )
      }
      if(this.survey.q4[4]){
        a4.push( this.$t('survey.q4.a5') )
      }
      return {
        1: this.survey.q1,
        2: this.survey.q2,
        3: this.survey.q3 == this.$t('survey.q3.a2') && this.survey.q3_text.length ? this.survey.q3 + this.survey.q3_text : this.survey.q3,
        4: a4.join(', '),
        5: this.survey.q5,
        6: this.survey.q6,
      }
    }
  },
  watch:{
    chapters(){
      if(this.chapters.length && this.chapters[this.chapters.length - 1].active){
        this.showForm = true;
      }
    },
    activeChapter(oldVal, newVal){
      if(oldVal?.id != newVal?.id){
        this.setScrollPositon()
      }
    }
  },
  methods:{
    setChapter(i){
      this.disableAutoScroll = true
      document.querySelector(`#player #chapter-${i}`).click()
      setTimeout(()=>{
        this.disableAutoScroll = false
      }, 500)
    },
    analyticsCall(val){
      let player = window["player"]
      if(player){
        let src = player.src()
        let params = {
          pid: src.split('/')[3],
          eiid: src.split('/')[4],
          eid: src.split('/')[5].replace('.mp4','').replace('.m3u8',''),
          player_version: (window.config)?window.config.player_version||'2.4.3':'2.4.3',
          player_session_id: player.session_id,
          video_url:src,
          event:'cta',
          event_value:val,
          full_landing_page: escape(window.location.href),
          autoplay: player.setup.autoplay,
          mute: player.setup.mute,
        };

        console.log('%csend c.a. =>','background:#11bb50;color:#fff;font-weight:900;padding:3px 5px;border-radius:5px;margin-right:10px',params)
        let url = new URL("https://stats-api.idomoo.co");
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
        fetch(url).then((resp)=>{
          console.log('%cc.a. resp =>','background:#1372cd;color:#fff;font-weight:900;padding:3px 5px;border-radius:5px;margin-right:10px',resp)
        })
      }
    },
    postSurvey(){
      if(!this.disabled){
        [1,2,3,4,5,6].forEach(id => {
          if(this.answers[id]){
            this.analyticsCall(`Q${id} | ${this.answers[id]}`)
          }
        })
        this.sendedForm = true
      }
    },
    setScrollPositon(){
      if(this.disableAutoScroll){
        return
      }
      let scrollPositon = 0
      if(this.activeChapter){
        const firstChild = this.$refs.chapters.querySelector('.li')
        const firstChildHeight = firstChild ? parseInt((firstChild.currentStyle || window.getComputedStyle(firstChild)).marginTop) + firstChild.offsetHeight : 0
        const visibleZone = this.$refs.chapters.offsetHeight
        const centralLine = visibleZone / 2

        scrollPositon = (this.activeChapter.id * firstChildHeight) - centralLine + (firstChildHeight * 0.7)
      }

      const startPos = this.$refs.chapters.scrollTop
      const delta = Math.abs(startPos - scrollPositon)
      const direction = startPos < scrollPositon
      let steps = 40
      const stepDelta = delta / steps
      let stepsDelta = stepDelta
      const step = ()=>{

        const newPos = direction ? startPos + stepsDelta : startPos - stepsDelta
        stepsDelta += stepDelta
        this.$refs.chapters.scrollTop = newPos

        steps--
        if(steps){
          setTimeout(step,5)
        }
      }
      step()
    },
    checkFile(url, tryNumber = 10){
      const controller = new AbortController();
      const signal = controller.signal;
      const timeoutId = setTimeout(() => {
        controller.abort();
      }, 3000);

      return fetch(url, { signal, method: 'HEAD' })
        .then(data => {
          console.log('check data', data);
          clearTimeout(timeoutId);
          return true
        })
        .catch(() => {
          if(tryNumber){
            return this.checkFile(url, tryNumber - 1)
          }else{
            return false
          }
        })
    },
    createPlayer(){
      window.idmPlayerCreate(this.player_options, "player");

      var player = window["player"];

      player.ready(()=>{

      var vjs_play_control = document.querySelector(".vjs-play-control");

      setTimeout(function () {
        vjs_play_control.setAttribute('aria-label', 'Click to pause video');
        vjs_play_control.removeAttribute('title');
        let pb = document.querySelector(".vjs-big-play-button")
        if(pb){
          pb.removeAttribute('title');
        }
      }, 500);

      vjs_play_control.onclick = function () {
        if (this.classList.contains("vjs-paused")) {
          this.setAttribute('aria-label', 'Click to pause video');
          setTimeout(function () {
            vjs_play_control.removeAttribute('title');
          }, 500);
        } else if (this.classList.contains("vjs-playing")) {
          this.setAttribute('aria-label', 'Click to play video');
          setTimeout(function () {
            vjs_play_control.removeAttribute('title');
          }, 500);
        }

      };


      var vjs_mute_control = document.querySelector(".vjs-mute-control");
      setTimeout(function () {
        vjs_mute_control.setAttribute('aria-label', 'Click to mute');
        vjs_mute_control.removeAttribute('title');
      }, 500)
      vjs_mute_control.onclick = function () {
        if (this.classList.contains("vjs-vol-3")) {
          this.setAttribute('aria-label', 'Click to unmute');
          setTimeout(function () {
            vjs_mute_control.removeAttribute('title');
          }, 500);
        } else if (this.classList.contains("vjs-vol-0")) {
          this.setAttribute('aria-label', 'Click to mute');
          setTimeout(function () {
            vjs_mute_control.removeAttribute('title');
          }, 500);
        }

      };

      var vjs_fullscreen_control = document.querySelector(".vjs-fullscreen-control");
      setTimeout(function () {
        vjs_fullscreen_control.setAttribute('aria-label', 'Click to turn on fullscreen mode');
        vjs_fullscreen_control.removeAttribute('title');
      }, 500)

      vjs_fullscreen_control.onclick = function () {
        if (this.getAttribute('aria-label') == 'Click to turn on fullscreen mode') {
          this.setAttribute('aria-label', 'Click to turn off fullscreen mode');
          setTimeout(function () {
            vjs_fullscreen_control.removeAttribute('title');
          }, 500);
        } else {
          this.setAttribute('aria-label', 'Click to turn on fullscreen mode');
          setTimeout(function () {
            vjs_fullscreen_control.removeAttribute('title');
          }, 500);
        }

      };
      

        player.on('timeupdate',()=>{
          this.time = player.currentTime()
          this.showChapters = true

          if(this.surveyShowTime && this.surveyShowTime < this.time){
            this.showForm = true;
        
          }
        })
        player.on('loadedmetadata',()=>{

          this.$emit('playerLoaded')

          const jsonUrl = player.src().replace('m3u8','json').replace('mp4','json')
          this.transcriptUrl = player.src().replace('.m3u8','').replace('.mp4','')

          fetch(jsonUrl)
            .then(d => d.json())
            .then(d => {
              this.chaptersData = d.chapters.sort((a, b) => a.time > b.time)
              const surveyEvent = d.timeline_events.find(e => e.event_stats == "Survey")
              if(surveyEvent){
                this.surveyShowTime = surveyEvent.time
              }
            })
            .catch(e => {
              console.log('json load error', e);
            })
        })

        player.on('error',()=>{
          this.$emit('playerError')
        })

      });

    }
  },
  mounted() {

   const urlParams = new URLSearchParams(window.location.search);

    if(!urlParams.get('id') && !urlParams.get('url')){
      const params = new URLSearchParams()
      const interest = ['firstName','shipDate','equipment','uniqueID','SwapFlag','BoxlessFlag','XumoFlag']
      const interest_lower = interest.map(v=>v.toLowerCase())

      urlParams.forEach((val,key)=>{
        if(interest_lower.includes( key.toLowerCase() )){
          const name = interest.find(v=>v.toLowerCase() == key.toLowerCase())
          params.set(name,val)
        }
      })

      const lang = urlParams.get('lang') || 'en'

      document.querySelector('html').setAttribute('lang',lang)

      const langLabels = {
        'en': 'English',
        'es': 'Español',
      }

      params.set('lang',lang)
      if(!this.badEquipment){
        this.player_options.opening_image.image_url = require(`@/assets/thumbnail_${lang}.jpg`)
      }else{
        this.player_options.autoplay = true
        this.player_options.mute = true
      }
      this.player_options.close_captions[0].label = langLabels[lang]

      //let src = process.env.VUE_APP_VIDEO_URL + '?' + encodeURIComponent(params.toString())
      //this.player_options.src = src
      
      fetch(process.env.VUE_APP_VIDEO_URL, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({data:Object.fromEntries(params)}) 
      })
        .then(resp => resp.json())
        .then(data => {
          this.checkFile(data.url)
            .then(result => {
              if(result){
                this.player_options.src = data.url
                this.createPlayer()
              }else{
                this.$emit('playerError')
                console.log('show error');
              }
            })
        })
        .catch(()=>{
          this.$emit('playerError')
        })

      if(this.badEquipment){
        delete(this.player_options.close_captions)
        delete(this.player_options.transcript)
      }

    }
  },
  beforeUnmount() {
    if(window["player"].dispose){
      window["player"].dispose()
    }
  }
}
</script>

<style scoped>
.headlines-container {
  text-align: center;
  margin-bottom: 20px;
}
.headlines-container.badEquipment{
  margin-top:30px;
}

.hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.headlines-container__text {
  font-family: "SpectrumSansRg", sans-serif;
  line-height: 120%;
  font-weight: bold;
  font-size: 23px;
  color: #000;
  text-transform: uppercase;
}

.headlines-container__text .br-mobile {
  display: none;
}

.input-radio {
  width: 100%;
  margin-left: 20px;
  padding: 5px 10px;
  font-family: "Gotham-Light", sans-serif;
}

.player-block {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding-bottom: 30px;
  display: flex;
  justify-content: center;
  overflow: hidden;

}
.player-block .player-box {
  width: 675.5555555556px;
  border: 10px solid #f2f2f2;
  background: #f2f2f2;
  max-width: 100%;
}
.player-block .player-box #idomoo_new_player {
  width: 100%;
}



.chapters{
  background-color: #f2f2f2;
  width: 50%;
  max-width: 420px;
  margin-left: 15px;
}

.chapters .active{
  color: #003057;
  font-size: 16px;
  font-weight: bold;
  padding: 15px 20px;
  color: #003057;
  padding-left: 35px;
  min-height: 65px;
  display: flex;
    align-items: center;
}

.chapters .active:before {
  font-family: 'iconsFont';
  content: '\f101';
  padding-right: 8px;
}

.chapters .list{
  max-height: 390px;
  overflow-x: auto;
}



.chapters.scrollDebug{
  position: relative;
}

.chapters.scrollDebug:after{
  display: block;
  height:2px;
  background-color: #0f0;
  width: 100%;
  position: absolute;
  top:calc(224px);
  left:0;
  content:"";
}
.chapters.scrollDebug .list{
  background-color: #00f;
}


.chapters .list .li{
  padding: 10px 10px 10px 20px;
  margin: 5px 10px;
  min-height: 50px;
  background-color: #fff;
  cursor: pointer;
  justify-content: space-between;
  display: flex;
  align-items: center;
  font-family: 'SpectrumSansRg',  sans-serif;

}
.chapters .list .li:hover{
  background-color: #cee2ec;
}

.chapters .list .li.viewed:after {
  content: '\f102';
  font-family: 'iconsFont';
  color: #003057;
  font-size: 23.2px;
}

.survey-radio {
  display: flex;
  align-items: center;
}

.survey-radio label {
  margin-left: 10px;
  line-height: 190%;
  min-width: fit-content;
}


.survey  {
  font-family: "Gotham-Light";
  line-height: 190%;
  color: #5a5a5c;
  font-size: 15px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  overflow: hidden;
}

.survey .survey-body,
.survey .sendedForm{
 padding-bottom: 50px;
}

.survey  input[type="radio"],
.survey  input[type="checkbox"] {
  margin: 0px 3px 0px 5px;
  width: 13px;
  min-width: 13px;
}

.survey fieldset {
  border: none;
  margin: 0px;
  padding: 0px;
  margin-bottom: 30px;
}

.survey textarea {
  width: 100%;
  padding: 5px 10px;
  font-family: "Gotham-Light", sans-serif;
}

.SurveySubmitButton {
  cursor: pointer;
  font-family: "Gotham-Bold";
  padding: 5px 8px;
  font-size: 14px;
  border-radius: 5px;
  border: 0.5px solid rgb(221, 221, 221);
  background-color: #f2f2f2;
  margin-left: 20px;
}


.survey-question-question {
  font-family: "Gotham-Bold", sans-serif;
  line-height: 190%;
}



.transcript{
  padding: 10px 10px 0;
}
.transcript a{
  color:#1757c6;
}


@media (max-width: 1250px) {
  .headlines-container {
    padding: 0 20px;
  }
  .player-block{
    flex-direction: column;
    align-items: center;
  }
  .player-box{
    width: 100% !important;
  }
  .chapters{
    background-color: #f2f2f2;
    width: 100%;
    max-width: 100%;
    margin-left: 0;
  }

  .survey .survey-body,
  .survey .sendedForm{
   padding: 0 15px 20px;
  }

  .transcript{
    padding: 10px;
    border-bottom: 1px solid #dedede;
  }
  .player-block .player-box{
    border-bottom: none;
    margin-bottom: 10px;
  }
  .chapters .list{
    max-height: 391px;
    border-bottom: 1px solid #dedede;
  }
}

@media (max-width: 600px) {
  .headlines-container__text {
    font-size: 20px;
  }

  .chapters .list .li, .chapters .active {
    font-size: 14px;
  }
}

/*chide player chapters menu
https://vue-loader.vuejs.org/guide/scoped-css.html#child-component-root-elements*/
#player >>> .vjs-interactive-bar{
  display: none !important;
}
</style>

<style>
.video-js .vjs-big-play-button {
  width: 3.2em !important;
  height: 3.2em !important;
  margin-top: -1.3em !important;
  margin-left: -1.7em !important;
  border-radius: 50%;
  background-size: contain !important;
  transition: all 0s;
}

.video-js:not(.vjs-fullscreen) .toolbar-position {
  opacity: 1 !important;
  pointer-events: unset !important;
}

.vjs-control.vjs-button.moo-button {
  display: none !important;
}

.video-js .vjs-big-play-button:hover {
  background-color: rgba(115, 133, 159, 0.5) !important;
}

@supports not (aspect-ratio: auto) {
  .idm-player {
    height: auto !important;
  }
}
</style>
